import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Ferme le menu lorsque la route change
  useEffect(() => {
    setIsMenuOpen(false); // Ferme le menu lorsqu'un changement de route est détecté
  }, [location.pathname]);

  return (
    <nav className="navbar navbar-expand-lg" style={{ position: "sticky" }}>
      <div className="container">
        {/* Logo */}
        <NavLink to="/" onClick={() => (window.location.href = "/")}>
          <img
            src={`${process.env.PUBLIC_URL}/img/logo-2.png`}
            className="logo-img"
            alt="Logo"
          />
        </NavLink>

        {/* Bouton pour mobile */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbar"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <GiHamburgerMenu size={24} /> {/* Taille ajustable */}
          </span>
        </button>

        {/* Menu */}
        <div
          className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
          id="navbar"
        >
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink
                exact
                className="nav-link"
                to="/"
                activeClassName="active"
              >
                Accueil
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/aPropos"
                activeClassName="active"
              >
                A propos de nous
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/rea" activeClassName="active">
                Réalisations
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <NavLink
                className="nav-link dropdown-toggle"
                to="/test"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                activeClassName="active"
              >
                Photographies
              </NavLink>
              <ul
                className="dropdown-menu dropdown-menu-end"
                style={{ left: "auto", right: "auto" }}
              >
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/reportage"
                    activeClassName="active"
                  >
                    Reportage
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/portrait"
                    activeClassName="active"
                  >
                    Portrait
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/evenementiel"
                    activeClassName="active"
                  >
                    Événementiel
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/industriel"
                    activeClassName="active"
                  >
                    Industriel
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/packshot"
                    activeClassName="active"
                  >
                    Packshot
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/photo/mariage"
                    activeClassName="active"
                  >
                    Mariage
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/contact"
                activeClassName="active"
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
